import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetFactorSetDangerousGood, resetFactorSetDangerousGoods } from '../../../../reducers/factorSetDangerousGoodsReducer';
import { FormType } from '../../../../constants/constants';
import AddFactorSetDangerousGoodsForm from './addFactorSetDangerousGoodsForm';

interface IAddFactorSetDangerousGoodsProps {
    classes: any;
    theme: Theme;
    match: any;
    resetFactorSetDangerousGood: () => any;
    resetFactorSetDangerousGoods: () => any;
    steps: Array<number>;
    factorSetDangerousGoodsId?: number;
    factorSetVersionId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetFactorSetDangerousGood: () => dispatch(resetFactorSetDangerousGood()),
    resetFactorSetDangerousGoods: () => dispatch(resetFactorSetDangerousGoods())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetDangerousGoodsProps) => {
    return {
        factorSetDangerousGoodsId: ownProps.match.params?.dangerousGoodId ? Number(ownProps.match.params?.dangerousGoodId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetDangerousGoods extends Component<IAddFactorSetDangerousGoodsProps> {
    componentWillUnmount() {
        const { resetFactorSetDangerousGood, resetFactorSetDangerousGoods } = this.props;

        resetFactorSetDangerousGood();
        resetFactorSetDangerousGoods();
    }

    render() {
        const { classes, steps, factorSetDangerousGoodsId, type, factorSetVersionId } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <AddFactorSetDangerousGoodsForm factorSetDangerousGoodsId={factorSetDangerousGoodsId} steps={steps} type={type} factorSetVersionId={factorSetVersionId} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetDangerousGoods));